import { useEffect, useState } from 'react';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { useSelector } from 'react-redux';
import './style.css';

const NodeSelect = props => {

    const nodes = useSelector( state => state.board.nodes ),
    [ options, setOptions ] = useState([]);

    // filter list
    useEffect(() => {

        const ary = [];

        for( let key in nodes ){
            if( !props.filter.includes( key ) ) ary.push( key )
        };

        setOptions( ary );

    }, [ setOptions, nodes, props.filter ]);

    if( options.length === 0 ) return null;

    return (
        <FormControl fullWidth>
            <TextField
                label={ props.label }
                onChange={ props.onChange }
                required
                select
                value={ props.value }>
                {
                    options.map(
                        ( id, index ) => (
                            <MenuItem key={ 'option-' + index } value={ id }>{ nodes[ id ].name }</MenuItem>
                        )
                    )
                }
            </TextField>
        </FormControl>       
    )
}

export default NodeSelect;